import { render, staticRenderFns } from "./SalesFlashTable.vue?vue&type=template&id=fe9928f2&scoped=true&"
import script from "./SalesFlashTable.vue?vue&type=script&lang=js&"
export * from "./SalesFlashTable.vue?vue&type=script&lang=js&"
import style0 from "./SalesFlashTable.vue?vue&type=style&index=0&id=fe9928f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9928f2",
  null
  
)

export default component.exports